<template>
  <div>
    <form @submit.prevent="doSearch" class="my-2">
      <div class="clearfix">
        <b-input-group>
          <input
            type="text"
            name="searchId"
            v-model="id"
            class="form-control"
            :placeholder="'Search by ' + simpleSearchKeys[0]"
          />
          <input
            type="text"
            name="searchName"
            v-model="name"
            class="ml-2 form-control"
            :placeholder="'Search by ' + simpleSearchKeys[1]"
          />
        </b-input-group>
      </div>
    </form>
  </div>
</template>

<script>

export default {
  computed: {
    id: {
      get() {
        return this.$store.state.searchStore.simpleSearch.id;
      },
      set(value) {
        this.$store.commit("searchStore/updateSimpleSearchValue", {
          key: "id",
          value: value,
        });
      }
    },
    name: {
      get() {
        return this.$store.state.searchStore.simpleSearch.name;
      },
      set(value) {
        this.$store.commit("searchStore/updateSimpleSearchValue", {
          key: "name",
          value: value,
        });
      }
    },
    states() {
      return this.$store.state.searchStore.states;
    },
    searchMode: {
      get() {
          return this.$store.state.searchStore.searchMode;
      },
      set(val) {
          this.$store.commit("searchStore/setSearchMode", val);
      },
    },
    errorMessage() {
      return this.$store.state.searchStore.errorMessage;
    },
    simpleSearchKeys() {
      return this.$store.state.searchStore.simpleSearchKeys;
    }
  }
}
</script>
